
import { Component, Vue } from "vue-property-decorator";
import { ExamV3Tem } from "@/lib/model/exambuilder/exam-v3/exam-v3";

import BuilderV3Steps from "@/views/ai-builder-v3/components/builder-v3-steps.vue";
import SetBasicTem from "@/views/ai-builder-v3/step-view/set-basic-tem.vue";
import ToolCheck from "./step-view/toolCheck.vue";
import SetQuestions from "./step-view/set-questions.vue";
import SetScore from "./step-view/set-score.vue";
import AskGoOn from "@/components/ask-go-on.vue";
import { Mind, PsycGaugeConfig } from "@/lib/model/exambuilder/exam-v2";

@Component({
  components: {
    BuilderV3Steps,
    SetBasicTem,
    ToolCheck,
    SetQuestions,
    SetScore,
    AskGoOn
  }
})
export default class TemBuilder extends Vue {
  temNameBackup = "";
  examTem: ExamV3Tem = new ExamV3Tem();
  dataInited = false;
  isEdit = false; // 是否编辑页面
  templateId = 0; // 模板id
  tacToken = "";
  cacheDimensionList = [];
  mindList: PsycGaugeConfig[] = [];
  isFirstEnter = true; // 是否第一次进入toolcheck
  userChangeScore = false;
  showZeroVisible = false;
  questionOrInspectScoreIsZeroList: any = [];

  // 步骤
  stepShow: boolean[] = [true, false, false, false]; // 四个步骤显隐
  currentStep = 0; // 当前步骤

  // 分别对应第2，3，4步
  stepsList = [
    { title: "考查项选择", isComplete: false },
    { title: "测评工具", isComplete: false },
    { title: "分数配置", isComplete: false }
  ];

  // 翻页限制速度，防止点击太快
  canChangePage = true;
  canCancelPage = true;

  askCancel = false;
  submitting = false;

  get pathText() {
    return this.isEdit ? "取消编辑" : "取消创建";
  }

  async getMindList(tacToken: string) {
    const res = await Mind.tacGet(tacToken);

    if (res.data.code !== 0) return;

    this.mindList = res.data.data.list.map((item: any) => {
      return new PsycGaugeConfig().assign(item);
    });
  }

  async created() {
    this.dataInited = false;
    this.currentStep = 0;

    // 没有传tacToken，直接取消
    if (!this.$route?.query?.token) {
      return this.cancelOk();
    }

    this.tacToken = this.$route.query.token as string;

    if (Number(this.$route?.query?.templateId)) {
      // 编辑进入，初始化，模板数据在mounted中获取
      this.templateId = Number(this.$route.query.templateId);
      this.isEdit = true;
      this.stepsList.forEach((el, ind) => {
        el.isComplete = true;
      });
    } else {
      // 创建进入
      this.examTem = new ExamV3Tem();
      this.$set(this.stepShow, 0, false);
      this.$nextTick(() => this.$set(this.stepShow, 0, true));
      this.dataInited = true;
    }

    // 进入url指定对应页面 默认0
    this.showCurrentStep(this.currentStep);
    await this.getMindList(this.tacToken);
  }

  getTemplateInfo({ data }: any) {
    const { source, msg } = data;

    if (source === "exam_tem_view") {
      try {
        this.examTem = new ExamV3Tem().assign(JSON.parse(msg));
        this.temNameBackup = this.examTem.templateName;
        this.dataInited = true;
      } catch (err) {
        console.error(err);
      }
    }
  }

  mounted() {
    window.addEventListener("message", this.getTemplateInfo, false);

    if (this.templateId) this.ready();
  }

  beforeDestory() {
    window.removeEventListener("message", this.getTemplateInfo);
  }

  // 通知tac后台postMessage数据
  ready() {
    window.parent.postMessage(
      {
        source: "exam_tem_edit_ready",
        msg: "ok"
      },
      "*"
    );
  }

  // 导航拦控制
  builderV3StepsClick(index: number) {
    this.isFirstEnter = false;
    this.showCurrentStep(index + 1);
  }

  // 步骤控制
  showCurrentStep(index: number) {
    this.currentStep = index;
    this.stepShow.forEach((item: boolean, i: number) => {
      this.$set(this.stepShow, i, index === i);
    });

    // 刷新保持当前页面 更新url
    const urlParams = this.$route.query;

    // 没有step
    if (!urlParams?.step) {
      const url = this.$route.fullPath + "&step=" + this.currentStep;
      return window.history.pushState("", "", url);
    }

    // url更新step
    urlParams.step = String(this.currentStep);
    const params = Object.entries(urlParams).reduce(
      (pre, [key, val]) => `${pre}${key}=${val}&`,
      "?"
    );
    const url = this.$route.path + params.substring(0, params.length - 1);
    window.history.pushState("", "", url);
  }

  // 防止点太快
  beforePageChange() {
    this.canChangePage = false;
    this.canCancelPage = false;

    setTimeout(() => (this.canChangePage = true), 300);
    setTimeout(() => (this.canCancelPage = true), 300);
  }

  // 完成
  async submit(jumpScoreIsZero = false) {
    const step4: any = this.$refs["step4"];

    const dataOK = await step4?.checkData();

    if (!dataOK) return;

    this.questionOrInspectScoreIsZeroList =
      step4?.questionOrInspectScoreIsZeroList;

    if (this.questionOrInspectScoreIsZeroList.length > 0 && !jumpScoreIsZero) {
      this.showZeroVisible = true;
      return;
    }

    console.log(123);

    window.parent.postMessage(
      {
        source: "exam_tem_save",
        msg: JSON.stringify(this.examTem.getSubmitData())
      },
      "*"
    );
  }

  // 上一步
  pre() {
    if (!this.canChangePage) return;
    this.beforePageChange();
    if (this.currentStep === 1) {
      this.isFirstEnter = false;
    }
    this.showCurrentStep(this.currentStep - 1);
  }

  // 下一步
  async next() {
    if (!this.canChangePage) return;
    this.beforePageChange();

    if (this.currentStep === 1) {
      this.isFirstEnter = false;
    }

    const ref: any = this.$refs[`step${this.currentStep + 1}`];
    const checkDataResult = await ref?.checkData();
    console.log(checkDataResult);
    if (!checkDataResult) return;

    // 导航条完成度状态变更
    if (!this.isEdit) {
      if (this.currentStep + 1 >= 2) {
        this.stepsList.forEach((el, index) => {
          if (index === this.currentStep - 1) {
            el.isComplete = true;
          }
        });
      }
    }

    this.showCurrentStep(this.currentStep + 1);
  }

  sureZero() {
    this.showZeroVisible = false;
    this.submit(true);
  }

  // 取消
  cancel() {
    if (!this.canChangePage) return;
    this.beforePageChange();
    this.askCancel = true;
  }

  cancelOk() {
    window.parent.postMessage(
      {
        source: "exam_tem_cancel"
      },
      "*"
    );
  }

  // 数据校验更新stepsList
  stepsListStatusChange() {
    const funDoMap = {
      0: "checkDataByTool",
      1: "checkDataByQuestion",
      2: "checkDataByScore"
    };
    for (let i = 0; i < this.stepsList.length; i++) {
      const flag = this.examTem.processInformation[funDoMap[i]](i == 0);
      if (i === 0 && !flag) {
        this.stepsList[0].isComplete = false;
        this.stepsList[1].isComplete = false;
        this.stepsList[2].isComplete = false;
        break;
      } else if (i === 0) {
        this.stepsList[0].isComplete = true;
      }
      if (i === 1 && !flag) {
        this.stepsList[1].isComplete = false;
        this.stepsList[2].isComplete = false;
        break;
      } else if (i === 1) {
        this.stepsList[1].isComplete = true;
      }
      if (i === 2 && !flag) {
        this.stepsList[2].isComplete = false;
        break;
      } else if (i === 2) {
        this.stepsList[2].isComplete = true;
      }
    }
  }
}
